import logo from './logo.svg';
import React, { useState } from 'react';
import NavBar from './NavBar';
import { motion } from 'framer-motion';
import './css/App.css';

function Home() {
  
  const currentDate = new Date().toLocaleDateString();
  const [token, setToken] = useState(null); // State to store the token
  const [error, setError] = useState(null);
  const [retval, setRetval] = useState(null); // State to store the JSON data


 const loginTokenTest =  async() => {
  // This function is just a test to see if the login token is working
  const loginData = {
    username: "andy.thorpe@gmail.com",
    password: "14.Somethingnew",
  };
  try {
    const response = await fetch("https://api.eu1.kt1.io/fleet/v2/auth/signin", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(loginData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    setRetval(data);
    setToken(data.accessToken);
    setError(null); 
  } catch (err) {
    setError(err.message);
    setToken(null);
  }
}


const getAndSaveExportData = async () => {

  //
  getAssetList({
    owner: "0abfcbe8-56aa-4d42-b7cb-9cdd33cfc31e"})
    return;
  const response = await fetch("https://export.eu1.kt1.io/v2/stream", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": `Bearer ${token}`
    },
  });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  const data = await response.json();
  setRetval(data);
  setError(null);
  return data;
}

const getAssetList = async ({
  owner,
  offset = 0,
  limit = 74,
  sort = '',
  filter = ''
}) => {
  //alert("Token: " + token);
  const params = new URLSearchParams();
  if (owner) params.append('owner', owner);
  if (offset !== undefined) params.append('offset', offset);
  if (limit !== undefined) params.append('limit', limit);
  if (sort) params.append('sort', sort);
  if (filter) params.append('filter', filter);

  const url = `https://api.eu1.kt1.io/fleet/v2/entities/assets?${params.toString()}`;

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": `${token}`
      },
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status} - ${response.statusText}`);
    }
    const data = await response.json();
    setRetval(data);
    setError(null);
    return data;
  } catch (err) {
    setError(err.message);
    return null;
  }
};



const getGEOList = async ({
  owner,
  offset = 0,
  limit = 74,
  sort = '',
  filter = ''
}) => {
  //alert("Token: " + token);
  const params = new URLSearchParams();
  if (owner) params.append('owner', owner);
  if (offset !== undefined) params.append('offset', offset);
  if (limit !== undefined) params.append('limit', limit);
  if (sort) params.append('sort', sort);
  if (filter) params.append('filter', filter);

  const url = `https://api.eu1.kt1.io/fleet/v2/entities/zones?${params.toString()}`;

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": `${token}`
      },
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status} - ${response.statusText}`);
    }
    const data = await response.json();
    setRetval(data);
    setError(null);
    return data;
  } catch (err) {
    setError(err.message);
    return null;
  }
};
 // GET /data/history/telemetry/{id}

 const getTelemetryData = async (id) => {
  setRetval(null);
 // The url also needs start: string
// in query
// The start date (in ISO format)

// end: string
// in query
// The end date (in ISO format)

const startdate = new Date();
startdate.setDate(startdate.getDate() - 7); // 7 days ago
const enddate = new Date();
 const start = startdate.toISOString(); // "2025/05/15 08:39:54";//
const end = enddate.toISOString(); // "2025/05/15 08:39:54";//
// const start = "2025/05/15 08:39:54";//
// const end = "2025/05/15 08:39:54";//
//const url = `https://api.eu1.kt1.io/fleet/v2/data/history/events/${id}/?start=${encodeURIComponent(start)}&end=${encodeURIComponent(end)}`;
  const url = `https://api.eu1.kt1.io/fleet/v2/data/history/events/${id}/?start=${start}&end=${end}`;
  // setError(url);
  // return; 
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": `${token}`
      },
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(`HTTP error! status: ${response.status} - ${JSON.stringify(errorData)}`);
    }
    const data = await response.json();
    setRetval(data);
    setError(null);
    return data;
  } catch (err) {
    setError(err.message);
    return null;
  }
}

  return (
    <div className="App">
     
      <header className="App-header">
      {/* <motion.img
         whileHover={{ scale: 1.1, rotate: 360 }}
         width={200}
          height={200}
         transition={{ duration: 0.3 }}
         
          src={require("./assets/Byte79_01.png")} 
          alt="logo"
        /> */}

      
       
      </header>
      <div className="App-body">

    <motion.div
          className="container"
          initial={{ opacity: 0, x: -100 }} // Start off-screen to the left
          whileInView={{ opacity: 1, x: 0 }} // Fade in and slide to position
          transition={{ duration: 0.8 }} // Animation duration
          viewport={{ once: true, amount: 0.2 }} // Trigger animation when 20% of the element is visible
        >
        <h1>Byte79 Ltd – Pioneering Software Solutions</h1>
        
        <div class="cta">
            <a href="#contact">Contact Us</a>
        </div>
        </motion.div>
    <motion.div
          className="container"
          initial={{ opacity: 0, x: 100 }} // Start off-screen to the left
          whileInView={{ opacity: 1, x: 0 }} // Fade in and slide to position
          transition={{ duration: 0.8 }} // Animation duration
          viewport={{ once: true, amount: 0.2 }} // Trigger animation when 20% of the element is visible
        >
         <h1>Innovative Mobile App Development for iOS & Android</h1>
<p>Byte79 Testbed!</p>
         
        </motion.div>

        {/* Repeat for other containers */}
        <motion.div
          className="container"
          initial={{ opacity: 0, x: -100 }} // Start off-screen to the right
          whileInView={{ opacity: 1, x: 0 }} // Fade in and slide to position
          transition={{ duration: 0.8 }}
          viewport={{ once: true, amount: 0.2 }}
        >
          <h1>Application testing</h1>
          <p>....</p>
        </motion.div>
        {error && (
          <p style={{ color: "red" }}>
            <strong>Error:</strong> {error}
          </p>
        )}
        </div>
      
      <div className="ticker">
        <div className="ticker-text">
          {/* <img className='App-logo' src={require("./assets/arrows-ball.png")} height={20} />
        <span>Update 15th April 2025. </span> */}
        <img src={require("./assets/info.png")} height={20} />
        <img className='App-logo' src={require("./assets/Byte79_02.png")} height={20} />
        <span>Site under construction</span></div>
      </div>
    </div>
  );
}

export default Home;
